import { styled } from 'styled-components';

export const ViewOptionsWrapper = styled.div`
  display: flex;
  width: fit-content;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
`;

export const ViewOptionsButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ViewOptionButton = styled.button``;
